var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { Component, Prop, Mixins, Watch } from 'vue-property-decorator';
import { Focusable } from "@/common/mixins/Focusable";
import { Savable } from '@/common/mixins/Savable';
import { AidTargetYearlyReport } from '@/common/types/AidTargetYearlyReport';
import LineControlComponent from '@/common/components/LineControl.vue';
import TextAreaRow from '@/common/components/TextAreaRow.vue';
import RadioButtonRow from '@/common/components/RadioButtonRow.vue';
import AttachmentTable from '@/common/components/AttachmentTable.vue';
import PersonnelExpensesControl from '@/template/components/aidTargetYearlyReport/controls/PersonnelExpensesControl.vue';
import GeneralExpensesControl from '@/template/components/aidTargetYearlyReport/controls/GeneralExpensesControl.vue';
import PremisesControl from '@/template/components/aidApplication/controls/PremisesControl.vue';
import AcquisitionsAndServicesControl from '@/template/components/aidTargetYearlyReport/controls/AcquisitionsAndServicesControl.vue';
import NumericInputRow from '@/common/components/NumericInputRow.vue';
import PlainTextControl from '@/common/components/PlainTextControl.vue';
import EntityService from '@/common/services/EntityService';
import LineControlWrapper from '@/common/types/LineControlWrapper';
import LineControlConfig from '@/common/types/LineControlConfig';
import AmountItemConfig from '@/common/types/AmountItemConfig';
import LineItemConfig from '@/common/types/LineItemConfig';
import { Guid } from 'guid-typescript';
import { LineItem } from '@/common/types/LineItem';
import { EstimateType } from '@/common/types/EstimateType';
import { isNullOrUndefined } from 'util';
import { AmountItemType } from '@/common/types/AmountItemType';
import { AidType } from '@/common/types/AidType';
import { PremiseType } from '@/common/types/PremiseType';
var AidTargetYearlyReportView = /** @class */ (function (_super) {
    __extends(AidTargetYearlyReportView, _super);
    function AidTargetYearlyReportView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.aupReportRequiredTotal = 300000;
        _this.entityService = new EntityService();
        return _this;
    }
    AidTargetYearlyReportView.prototype.mounted = function () {
        this.redirectUsersWithNoProcuration();
        this.preventSendingIfNecessary();
        this.focusOnFirstTag("h1");
    };
    AidTargetYearlyReportView.prototype.preventSendingIfNecessary = function () {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.hasProcuration) return [3 /*break*/, 2];
                        this.$store.commit("vuexPageModule/SET_CUSTOMREADONLY", true);
                        return [4 /*yield*/, this.$store.dispatch("vuexPageModule/setPreventSending", "AidTargetYearlyReport.ProcurationOnly")];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    AidTargetYearlyReportView.prototype.redirectUsersWithNoProcuration = function () {
        if (!this.hasProcuration) {
            this.$router.push("/");
        }
    };
    Object.defineProperty(AidTargetYearlyReportView.prototype, "hasProcuration", {
        get: function () {
            var user = this.$store.state.vuexPageModule.currentUser;
            if (user) {
                return user.hasProcuration;
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AidTargetYearlyReportView.prototype, "features", {
        get: function () {
            var config = this.$store.state.vuexPageModule.configuration;
            return config.featureConfiguration;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AidTargetYearlyReportView.prototype, "attachments", {
        get: function () {
            this.setDelegationAttachmentRequired();
            return this.report.attachments;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AidTargetYearlyReportView.prototype, "personnelExpenses", {
        get: function () {
            return this.report.budgetaryEstimate.expenses.personnelExpenses;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AidTargetYearlyReportView.prototype, "externalServices", {
        get: function () {
            return this.report.budgetaryEstimate.expenses.externalServices;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AidTargetYearlyReportView.prototype, "premises", {
        get: function () {
            return this.report.budgetaryEstimate.expenses.premises;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AidTargetYearlyReportView.prototype, "premiseExpenses", {
        get: function () {
            return this.report.budgetaryEstimate.expenses.premiseExpenses;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AidTargetYearlyReportView.prototype, "premisesWrapper", {
        get: function () {
            var e_1, _a;
            this.setPremiseExpensesRequired();
            var showRowTotal = false;
            var showColTotal = true;
            var showActions = false;
            var maxRows = null;
            var config = new LineControlConfig(showRowTotal, showColTotal, showActions, this.createNewLineItem, maxRows);
            var _loop_1 = function (line) {
                var computationConfig = new LineItemConfig();
                if (this_1.premiseExpensesRequired && line.type == EstimateType.Expenses_Other_PremiseExpenses) {
                    computationConfig.addAmountItemConfig(this_1.premiseExpenses.summary.columnHeaders[1].value, new AmountItemConfig(null, { min_value: 1 }));
                }
                computationConfig.addAmountItemConfig(this_1.premiseExpenses.summary.columnHeaders[2].value, new AmountItemConfig(function () { return line.amountItems[0].amount - line.amountItems[1].amount; }, { min_value: false }));
                config.addLineItemConfig(line.key, computationConfig);
            };
            var this_1 = this;
            try {
                for (var _b = __values(this.premiseExpenses.summary.lineItems), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var line = _c.value;
                    _loop_1(line);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return new LineControlWrapper(this.premiseExpenses.summary, config);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AidTargetYearlyReportView.prototype, "profits", {
        get: function () {
            return this.report.budgetaryEstimate.profits;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AidTargetYearlyReportView.prototype, "totals", {
        get: function () {
            return this.report.budgetaryEstimate.totals;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AidTargetYearlyReportView.prototype, "showGeneralExpenses", {
        get: function () {
            return this.report.aidType != AidType.Ay;
        },
        enumerable: false,
        configurable: true
    });
    AidTargetYearlyReportView.prototype.calculateShowAupRequired = function () {
        var e_2, _a;
        var _b, _c, _d, _e, _f;
        var realizedAmount = 0;
        var expenses = (_c = (_b = this.totals.totalSummary) === null || _b === void 0 ? void 0 : _b.lineItems) === null || _c === void 0 ? void 0 : _c.filter(function (x) { return x.key == "AidTargetYearlyReport.Expenses"; });
        if (expenses.length > 0) {
            var realizedExpenses = expenses[0].amountItems.filter(function (x) { return x.columnKey == "AidTargetYearlyReport.ColumnHeaders.Realized"; });
            if (realizedExpenses.length > 0) {
                realizedAmount = Math.abs(realizedExpenses[0].amount);
            }
        }
        var nonSteaProfit = 0;
        var lines = (_e = (_d = this.profits) === null || _d === void 0 ? void 0 : _d.breakdown) === null || _e === void 0 ? void 0 : _e.lineItems;
        if (lines != null) {
            try {
                for (var _g = __values(lines.filter(function (x) { return x.key != 'AidTargetYearlyReport.Profits.AppliedAid' && x.key != 'AidTargetYearlyReport.Profits.AdvancesOrDeferred'; })), _h = _g.next(); !_h.done; _h = _g.next()) {
                    var line = _h.value;
                    var realizedColumn = line.amountItems.find(function (x) { return x.columnKey == 'AidTargetYearlyReport.ColumnHeaders.Realized'; });
                    if (realizedColumn) {
                        nonSteaProfit += (_f = realizedColumn.amount) !== null && _f !== void 0 ? _f : 0;
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_h && !_h.done && (_a = _g.return)) _a.call(_g);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
        return realizedAmount - nonSteaProfit >= this.aupReportRequiredTotal;
    };
    AidTargetYearlyReportView.prototype.totalProfits = function (col) {
        var _a;
        if (this.profits.breakdown && this.profits.breakdown.numberOfLineItems > 0) {
            return (_a = this.profitsWrapper.columnTotals[col].total) !== null && _a !== void 0 ? _a : 0;
        }
        return 0;
    };
    // Expenses are given as a negative number to enable calculation of total value
    AidTargetYearlyReportView.prototype.totalExpenses = function (col) {
        var expenses = 0;
        if (this.personnelExpensesWrapper.columnTotals[col].total > 0)
            expenses -= this.personnelExpensesWrapper.columnTotals[col].total;
        if (this.premisesWrapper.columnTotals[col].total > 0)
            expenses -= this.premisesWrapper.columnTotals[col].total;
        if (this.operationalExpensesWrapper.columnTotals[col].total > 0)
            expenses -= this.operationalExpensesWrapper.columnTotals[col].total;
        if (this.generalExpensesWrapper.columnTotals[col].total > 0)
            expenses -= this.generalExpensesWrapper.columnTotals[col].total;
        return expenses;
    };
    Object.defineProperty(AidTargetYearlyReportView.prototype, "totalsWrapper", {
        get: function () {
            return this.totalsLineControlWrapper(this.totals.totalSummary);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AidTargetYearlyReportView.prototype, "showGrantorsAndPurposes", {
        get: function () {
            return this.profits.breakdown.lineItems.findIndex(function (x) { return x.type == EstimateType.Profits_Other || x.type == EstimateType.Profits_OtherPublicAid; }) != -1;
        },
        enumerable: false,
        configurable: true
    });
    AidTargetYearlyReportView.prototype.onManuallyAddedProfitsChange = function (value) {
        if (!value) {
            this.profits.grantorsAndPurposes = "";
            this.forceSave();
        }
    };
    Object.defineProperty(AidTargetYearlyReportView.prototype, "operationalExpenses", {
        get: function () {
            return this.report.budgetaryEstimate.expenses.operationalExpenses;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AidTargetYearlyReportView.prototype, "operationalExpensesWrapper", {
        get: function () {
            var e_3, _a;
            this.setDelegationAmountRequired();
            this.operationalExpenses.breakdown;
            var showRowTotal = false;
            var showColTotal = true;
            var showActions = false;
            var maxRows = null;
            var config = new LineControlConfig(showRowTotal, showColTotal, showActions, this.createNewLineItem, maxRows);
            var _loop_2 = function (line) {
                var computationConfig = new LineItemConfig();
                if (this_2.delegationAmountRequired && line.type == EstimateType.Expenses_Operational_Delegated) {
                    computationConfig.addAmountItemConfig(this_2.operationalExpenses.breakdown.columnHeaders[1].value, new AmountItemConfig(null, { min_value: 1 }));
                }
                computationConfig.addAmountItemConfig(this_2.operationalExpenses.breakdown.columnHeaders[2].value, new AmountItemConfig(function () { return line.amountItems[0].amount - line.amountItems[1].amount; }, { min_value: false }));
                config.addLineItemConfig(line.key, computationConfig);
            };
            var this_2 = this;
            try {
                for (var _b = __values(this.operationalExpenses.breakdown.lineItems), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var line = _c.value;
                    _loop_2(line);
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_3) throw e_3.error; }
            }
            return new LineControlWrapper(this.operationalExpenses.breakdown, config);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AidTargetYearlyReportView.prototype, "generalExpenses", {
        get: function () {
            return this.report.budgetaryEstimate.expenses.generalExpenses;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AidTargetYearlyReportView.prototype, "profitsWrapper", {
        get: function () {
            var e_4, _a;
            var showRowTotal = false;
            var showColTotal = true;
            var showActions = true;
            var maxRows = null;
            var config = new LineControlConfig(showRowTotal, showColTotal, showActions, this.createNewLineItem, maxRows);
            var _loop_3 = function (line) {
                var computationConfig = new LineItemConfig();
                if (line.key == "AidTargetYearlyReport.Profits.AdvancesOrDeferred") {
                    computationConfig.addAmountItemConfig(this_3.profits.breakdown.columnHeaders[0].value, new AmountItemConfig(null, { min_value: false }));
                    computationConfig.addAmountItemConfig(this_3.profits.breakdown.columnHeaders[1].value, new AmountItemConfig(null, { min_value: false }));
                }
                computationConfig.addAmountItemConfig(this_3.profits.breakdown.columnHeaders[2].value, new AmountItemConfig(function () { return line.amountItems[1].amount - line.amountItems[0].amount; }, { min_value: false }));
                config.addLineItemConfig(line.key, computationConfig);
            };
            var this_3 = this;
            try {
                for (var _b = __values(this.profits.breakdown.lineItems), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var line = _c.value;
                    _loop_3(line);
                }
            }
            catch (e_4_1) { e_4 = { error: e_4_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_4) throw e_4.error; }
            }
            return new LineControlWrapper(this.profits.breakdown, config);
        },
        enumerable: false,
        configurable: true
    });
    AidTargetYearlyReportView.prototype.totalsLineControlWrapper = function (lineControl) {
        var _this = this;
        var showRowTotal = false;
        var showColTotal = true;
        var config = new LineControlConfig(showRowTotal, showColTotal, false, this.createNewLineItem, null);
        //Profits
        var row = 0;
        var profitsRow = lineControl.lineItems[row];
        var computationConfig = new LineItemConfig();
        computationConfig.addAmountItemConfig(lineControl.columnHeaders[0].value, new AmountItemConfig(function () { return _this.totalProfits(0); }, { min_value: false }));
        computationConfig.addAmountItemConfig(lineControl.columnHeaders[1].value, new AmountItemConfig(function () { return _this.totalProfits(1); }, { min_value: false }));
        computationConfig.addAmountItemConfig(lineControl.columnHeaders[2].value, new AmountItemConfig(function () { return profitsRow.amountItems[1].amount - profitsRow.amountItems[0].amount; }, { min_value: false }));
        config.addLineItemConfig(profitsRow.key, computationConfig);
        //Expenses
        row = 1;
        var expensesRow = lineControl.lineItems[row];
        computationConfig = new LineItemConfig();
        computationConfig.addAmountItemConfig(lineControl.columnHeaders[0].value, new AmountItemConfig(function () { return _this.totalExpenses(0); }, { min_value: false }));
        computationConfig.addAmountItemConfig(lineControl.columnHeaders[1].value, new AmountItemConfig(function () { return _this.totalExpenses(1); }, { min_value: false }));
        computationConfig.addAmountItemConfig(lineControl.columnHeaders[2].value, new AmountItemConfig(function () { return expensesRow.amountItems[1].amount - expensesRow.amountItems[0].amount; }, { min_value: false }));
        config.addLineItemConfig(expensesRow.key, computationConfig);
        return new LineControlWrapper(lineControl, config);
    };
    Object.defineProperty(AidTargetYearlyReportView.prototype, "generalExpensesWrapper", {
        get: function () {
            var e_5, _a;
            var _this = this;
            var showRowTotal = false;
            var showColTotal = true;
            var showActions = false;
            var maxRows = null;
            var config = new LineControlConfig(showRowTotal, showColTotal, showActions, function () { return null; }, maxRows);
            var _loop_4 = function (line) {
                var computationConfig = new LineItemConfig();
                computationConfig.addAmountItemConfig(this_4.generalExpenses.summary.columnHeaders[1].value, new AmountItemConfig(function () { return _this.totalAidGeneralExpenses; }));
                computationConfig.addAmountItemConfig(this_4.generalExpenses.summary.columnHeaders[2].value, new AmountItemConfig(function () { return line.amountItems[0].amount - line.amountItems[1].amount; }, { min_value: false }));
                config.addLineItemConfig(line.key, computationConfig);
            };
            var this_4 = this;
            try {
                for (var _b = __values(this.generalExpenses.summary.lineItems), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var line = _c.value;
                    _loop_4(line);
                }
            }
            catch (e_5_1) { e_5 = { error: e_5_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_5) throw e_5.error; }
            }
            return new LineControlWrapper(this.generalExpenses.summary, config);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AidTargetYearlyReportView.prototype, "personnelExpensesWrapper", {
        get: function () {
            var e_6, _a;
            var _this = this;
            var showRowTotal = false;
            var showColTotal = true;
            var showActions = false;
            var maxRows = null;
            var config = new LineControlConfig(showRowTotal, showColTotal, showActions, function () { return null; }, maxRows);
            var _loop_5 = function (line) {
                var computationConfig = null;
                if (line.key == "AidTargetYearlyReport.PersonnelExpenses.AidYearPersonnelExpenses.HourlyWages") {
                    computationConfig = new LineItemConfig([function () { return line.amountItems[1].amount > _this.features.explanationLimit_AidTargetYearlyReport_HourlyWages; }]);
                }
                else {
                    computationConfig = new LineItemConfig();
                }
                computationConfig.addAmountItemConfig(this_5.personnelExpenses.aidYearPersonnelExpenses.columnHeaders[2].value, new AmountItemConfig(function () { return line.amountItems[0].amount - line.amountItems[1].amount; }, { min_value: false }));
                config.addLineItemConfig(line.key, computationConfig);
            };
            var this_5 = this;
            try {
                for (var _b = __values(this.personnelExpenses.aidYearPersonnelExpenses.lineItems), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var line = _c.value;
                    _loop_5(line);
                }
            }
            catch (e_6_1) { e_6 = { error: e_6_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_6) throw e_6.error; }
            }
            return new LineControlWrapper(this.personnelExpenses.aidYearPersonnelExpenses, config);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AidTargetYearlyReportView.prototype, "totalAidGeneralExpenses", {
        get: function () {
            if (this.generalExpenses.breakdown && this.generalExpenses.breakdown.length > 0) {
                var sum = this.generalExpenses.breakdown.reduce(function (a, b) { return a + (b.aidTargetedSum ? b.aidTargetedSum : 0); }, 0);
                return sum;
            }
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AidTargetYearlyReportView.prototype, "delegationAttachmentRequired", {
        get: function () {
            var delegationLine = this.operationalExpenses.breakdown.lineItems.find(function (x) { return x.type == EstimateType.Expenses_Operational_Delegated; });
            var delegationRealized = delegationLine ? delegationLine.amountItems.find(function (x) { return x.type == AmountItemType.Realized; }).amount : 0;
            return delegationRealized > 0;
        },
        enumerable: false,
        configurable: true
    });
    AidTargetYearlyReportView.prototype.setDelegationAttachmentRequired = function () {
        var delegationAttachment = this.report.attachments.find(function (x) { return x.displayKey == "AidTargetYearlyReport.Attachments.DelegationSummary"; });
        if (delegationAttachment && delegationAttachment.isRequired != this.delegationAttachmentRequired) {
            delegationAttachment.isRequired = this.delegationAttachmentRequired;
        }
    };
    Object.defineProperty(AidTargetYearlyReportView.prototype, "delegationAmountRequired", {
        get: function () {
            var delegationAttachment = this.attachments.find(function (x) { return x.displayKey == "AidTargetYearlyReport.Attachments.DelegationSummary"; });
            return delegationAttachment && !!delegationAttachment.blobUri;
        },
        enumerable: false,
        configurable: true
    });
    AidTargetYearlyReportView.prototype.setDelegationAmountRequired = function () {
        var delegationLine = this.operationalExpenses.breakdown.lineItems.find(function (x) { return x.type == EstimateType.Expenses_Operational_Delegated; });
        var delegationRealizedItem = delegationLine ? delegationLine.amountItems.find(function (x) { return x.type == AmountItemType.Realized; }) : null;
        if (delegationRealizedItem && delegationRealizedItem.isRequired != this.delegationAmountRequired) {
            delegationRealizedItem.isRequired = this.delegationAmountRequired;
        }
    };
    Object.defineProperty(AidTargetYearlyReportView.prototype, "premiseExpensesRequired", {
        get: function () {
            if (this.premises.premiseTypes.findIndex(function (x) { return x == PremiseType.OwnPremises || x == PremiseType.RelatedOrganisationPremises || x == PremiseType.Rental; }) != -1) {
                return true;
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    AidTargetYearlyReportView.prototype.setPremiseExpensesRequired = function () {
        var premisesLine = this.premiseExpenses.summary.lineItems.find(function (x) { return x.type == EstimateType.Expenses_Other_PremiseExpenses; });
        var premisesRealizedItem = premisesLine ? premisesLine.amountItems.find(function (x) { return x.type == AmountItemType.Realized; }) : null;
        if (premisesRealizedItem && premisesRealizedItem.isRequired != this.premiseExpensesRequired) {
            premisesRealizedItem.isRequired = this.premiseExpensesRequired;
        }
    };
    /**
   * Create new line item.
   * @param columns columns
   */
    AidTargetYearlyReportView.prototype.createNewLineItem = function (columns) {
        var lineItem = new LineItem();
        lineItem.name = null;
        lineItem.isReadOnly = false;
        lineItem.isLocalized = false;
        lineItem.canDelete = true;
        lineItem.key = "UserAdded." + Guid.create().toString();
        lineItem.type = EstimateType.Unknown;
        var amountItems = [];
        for (var i = 0; i < columns.length; i++) {
            amountItems.push({
                amount: null,
                isComputed: i == 2,
                isReadOnly: i == 0,
                isRequired: i == 1,
                columnKey: columns[i].value,
                lineItemKey: lineItem.key,
                type: columns[i].type
            });
        }
        lineItem.amountItems = amountItems;
        return lineItem;
    };
    AidTargetYearlyReportView.prototype.createPremiseData = function () {
        var year = this.report.reportYear;
        var item = { yearlyData: [] };
        item.yearlyData.push({ year: year, name: null, owner: null, postalCode: null, area: null, costs: null, otherCosts: null });
        return item;
    };
    Object.defineProperty(AidTargetYearlyReportView.prototype, "otherProfitOptions", {
        get: function () {
            var optionsArray = [
                this.getEstimateTypeOption(EstimateType.Profits_OwnFunding),
                this.getEstimateTypeOption(EstimateType.Profits_CustomerFees),
                this.getEstimateTypeOption(EstimateType.Profits_OtherPublicAid),
                this.getEstimateTypeOption(EstimateType.Profits_Other)
            ];
            return optionsArray;
        },
        enumerable: false,
        configurable: true
    });
    AidTargetYearlyReportView.prototype.showExplanationOfBudgetedAndTotalDiscrepancy = function () {
        // Do not show explanation field for Ay or Ak aid targets if realized total is negative AND budgeted deposit or receivable is exactly zero.
        if (this.totalsWrapper.columnTotals[1].total < 0 && this.totals.budgetedDepositOrReceivable == 0 && (this.report.aidType == AidType.Ak || this.report.aidType == AidType.Ay))
            return false;
        var diff = Math.abs(this.totals.budgetedDepositOrReceivable - this.totalsWrapper.columnTotals[1].total);
        if ((this.totals.budgetedDepositOrReceivable || this.totals.budgetedDepositOrReceivable == 0) && diff > this.features.explanationLimit_DepositOrReceivableDiscrepancy)
            return true;
        return false;
    };
    AidTargetYearlyReportView.prototype.showNextYearApplicationDeferredAmount = function () {
        return !isNullOrUndefined(this.totals.nextYearApplicationDeferredAmount) && (this.report.aidType == AidType.Ak || this.report.aidType == AidType.Ay);
    };
    AidTargetYearlyReportView.prototype.showExplanationOfDeferredDiscrepancy = function () {
        var _a, _b;
        var diff = (this.totalsWrapper.columnTotals[1].total + ((_a = this.totals.unpaidAmount) !== null && _a !== void 0 ? _a : 0) - ((_b = this.totals.nextYearApplicationDeferredAmount) !== null && _b !== void 0 ? _b : 0));
        // Expenses are negative, transformed to positive for calculations.
        var totalExpenses = -this.totalExpenses(1);
        if (this.showNextYearApplicationDeferredAmount() && diff > 0 && (diff > (totalExpenses * this.features.explanationCoefficient_Deferred))) {
            return true;
        }
        return false;
    };
    AidTargetYearlyReportView.prototype.getEstimateTypeOption = function (key) {
        return {
            id: key,
            name: this.$t("Enums.EstimateType." + EstimateType[key]).toString()
        };
    };
    var _a;
    __decorate([
        Prop({ type: Object, required: true }),
        __metadata("design:type", typeof (_a = typeof AidTargetYearlyReport !== "undefined" && AidTargetYearlyReport) === "function" ? _a : Object)
    ], AidTargetYearlyReportView.prototype, "report", void 0);
    __decorate([
        Watch("showGrantorsAndPurposes"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], AidTargetYearlyReportView.prototype, "onManuallyAddedProfitsChange", null);
    AidTargetYearlyReportView = __decorate([
        Component({
            name: "AidTargetYearlyReportView",
            components: {
                LineControlComponent: LineControlComponent,
                TextAreaRow: TextAreaRow,
                RadioButtonRow: RadioButtonRow,
                AttachmentTable: AttachmentTable,
                PersonnelExpensesControl: PersonnelExpensesControl,
                PremisesControl: PremisesControl,
                GeneralExpensesControl: GeneralExpensesControl,
                AcquisitionsAndServicesControl: AcquisitionsAndServicesControl,
                NumericInputRow: NumericInputRow,
                PlainTextControl: PlainTextControl
            }
        })
    ], AidTargetYearlyReportView);
    return AidTargetYearlyReportView;
}(Mixins(Focusable, Savable)));
export default AidTargetYearlyReportView;
